import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, IconButton } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ActivitiesCompleted from "../ActivitiesCompleted/ActivitiesCompleted";
import ProgressBar from "../ProgressBar/ProgressBar";
import { useTranslation } from "react-i18next";

export default function CourseCardSummary(props) {
  const { t } = useTranslation();
  const {
    expanded,
    onActivitiesExpandedChange,
    totalActivities,
    numActivitiesCompleted,
    hasExpansionPanel,
    showProgress
  } = props;
  return (
    <>
      {totalActivities && totalActivities >= 0 && (
        <Box
          display="flex"
          alignItems="flex-end"
          mt={{ xs: 2.5, md: 0 }}
          maxWidth={578}
          justifyContent="space-between"
        >
          {hasExpansionPanel && (
            <Box display="flex" mb={-1} zIndex={1}>
              <Typography variant="body2" color="textPrimary" noWrap>
                {t("courseCard.courseCardSummary.shortCourse", {
                  totalActivities: totalActivities,
                  postfix: totalActivities > 1 ? "s" : ""
                })}
              </Typography>
              <Box pl={{ sm: 0.5, lg: 3 }} mt="-3px">
                <IconButton onClick={onActivitiesExpandedChange} size="small">
                  {expanded ? (
                    <ExpandLess color="primary" />
                  ) : (
                    <ExpandMore color="primary" />
                  )}
                </IconButton>
              </Box>
            </Box>
          )}
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="flex-end"
            margin={{ xs: "auto", lg: 0 }}
            alignItems="center"
            flex={1}
          >
            <Box display="flex" flexDirection="column" alignItems="center">
              {showProgress && (
                <ActivitiesCompleted
                  totalSteps={totalActivities}
                  completedSteps={numActivitiesCompleted}
                  fontSize="0.6875rem"
                />
              )}
              {showProgress && (
                <ProgressBar
                  totalSteps={totalActivities}
                  completedSteps={numActivitiesCompleted}
                  color="primary"
                  small
                />
              )}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
}

CourseCardSummary.propTypes = {
  hasExpansionPanel: PropTypes.bool,
  expanded: PropTypes.bool,
  numActivitiesCompleted: PropTypes.number,
  onActivitiesExpandedChange: PropTypes.func,
  totalActivities: PropTypes.number
};

CourseCardSummary.defaultProps = {
  hasExpansionPanel: true
};
